<template>
  <DiagramEditor
    :value="graphData"
    @input="importGraphData"
  />
</template>

<script>
import DiagramEditor from './DiagramEditor'

export default {
  components: {
    DiagramEditor
  },
  data () {
    return {
      graphData: {
        width: 1500,
        height: 1000,
        background: "rgb(245, 247, 251)",
        nodes: [],
        links: []
      }
    }
  },
  methods: {
    importGraphData (val) {
      this.graphData = val
    }
  }
}
</script>
